import React from 'react';
import '../auth.css';
import Logo from './logo.js';
import ModalModal from './modal.js';


const Forget =() =>{

return (
<div className="background_cover">
  <div className="container">
  <Logo></Logo>
  <ModalModal text_img="CONTACT US Type"></ModalModal>




  </div>

  </div>

);
};


export default Forget;